import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'
import swal from 'sweetalert2';

export default class CartDeletor extends HTMLAnchorElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.watch();
    }

    disconnectedCallback() {
        this.unwatch();
    }

    watch() {
        this.addEventListener('click', function (e) {
            e.preventDefault();
            this.deleteCart();
        });
    }

    unwatch() {
        this.removeEventListener('click', function (e) {
            e.preventDefault();
            this.deleteCart();
        });
    }

    deleteCart() {
        if ( ! this.mainContainer) {
            return;
        }

        this.mainContainer.askToDelete(this.dataset.message, this.dataset.button,() => {
            const requestor = new Requestor();
            requestor.sendRequest( this.href, 'GET', '', () => {
                window.location.reload();
            });
        });
    }
}
